import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'src/utils/debounce';

export const useDebounce = (callback: () => void) => {
  const ref = useRef<() => void>(callback);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, 1000);
  }, []);

  return debouncedCallback;
};
